"use client";

import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";

import faqs from "@/data/faqHome";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="overflow-hidden">
      <div className="max-w-[1170px] w-full mx-auto px-4 sm:px-8 xl:px-0 mb-20">
        {/* <!-- section title --> */}
        <div className="mb-10 flex items-center justify-between">
          <div>
            <span className="flex items-center gap-2.5 font-medium text-dark mb-1.5">
              <Image
                src="/images/icons/icon-07.svg"
                alt="icon"
                width={17}
                height={17}
              />
              Seputar Rental
            </span>
            <h2 className="font-semibold text-xl xl:text-heading-6 text-dark">
              Pertanyaan Umum seputar Sewa Laptop Jakarta & Sekitarnya
            </h2>
            <p className="text-custom-sm">
              Semua jawaban penting tentang rental laptop, mulai dari <strong>harga sewa laptop</strong>, <strong>durasi pemakaian</strong>, <strong>jenis & spek unit</strong>, hingga <strong>cara booking tercepat</strong> kami rangkum disini.<br /> Jadi kamu bisa merasa aman, jelas, dan yakin 100% sebelum sewa laptop untuk kebutuhan di <strong>Jakarta, Bogor, Tangerang, atau Bekasi</strong>.
            </p>
          </div>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border rounded-md p-4 cursor-pointer bg-white shadow hover:shadow-md transition"
              onClick={() => toggleIndex(i)}
              aria-expanded={openIndex === i}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") toggleIndex(i);
              }}
            >
              <div className="flex justify-between items-center">
                <h3
                  className="text-lg font-medium"
                  dangerouslySetInnerHTML={{ __html: faq.question }}
                />
                <span className="text-xl select-none">{openIndex === i ? "−" : "+"}</span>
              </div>
              {openIndex === i && (
                <p
                  className="mt-2 text-custom-sm text-gray-700"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              )}
            </div>
          ))}
        </div>

      </div>
    </section >
  );
}
